import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RecipeNutrition } from '../types';

interface RecipeBankNutritionTabProps {
  nutrition: RecipeNutrition[];
}

/** Read-only nutrition display - values are recipe-derived from Recipe V2, never calculated here. */
const RecipeBankNutritionTab = ({ nutrition }: RecipeBankNutritionTabProps) => {
  const { t } = useTranslation('recipeV2');

  if (!nutrition.length) {
    return <Typography color="text.secondary">{t('recipeBank.detail.noNutrition', 'Nutrition information is not available for this recipe.')}</Typography>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{t('nutrition.nutrient', 'Nutrient')}</TableCell>
          <TableCell align="right">{t('nutrition.value', 'Value')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {nutrition.map((entry) => (
          <TableRow key={entry.code}>
            <TableCell>{entry.name}</TableCell>
            <TableCell align="right">
              {entry.value != null ? `${entry.value}${entry.valueUom ? ` ${entry.valueUom}` : ''}` : '—'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default RecipeBankNutritionTab;
